import React from "react";
import "./Group70.css";

function Group70() {
  return (
    <div className="group-70">
      <div className="group-81">
        <div className="group-69">
          <img className="path-59" src="/img/path-59@1x.png" />
          <img className="path-60" src="/img/path-60@1x.png" />
          <img className="path-61" src="/img/path-61@1x.png" />
          <div className="path-container-10">
            <img className="path-62" src="/img/path-62@1x.png" />
            <img className="path-63" src="/img/path-63@1x.png" />
          </div>
        </div>
        <div className="level-up avenir-heavy-normal-eerie-black-18px">LEVEL UP</div>
        <p className="achieve-affiliate-earn-10-per-1 avenir-book-normal-eerie-black-12px">
          ACHIEVE AFFILIATE &amp; EARN 10% PER $1
        </p>
        <div className="learn-more-1 avenir-medium-eerie-black-12px">LEARN MORE</div>
      </div>
    </div>
  );
}

export default Group70;
